import styled from '@emotion/styled';
import {Link} from 'react-router-dom';
import {colors, fonts} from 'ui/config';
import arrowBack from 'assets/img/arrowBackBlack.svg';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingLeft: 25,
  paddingRight: 25,
});

export const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '100vw',
  boxSizing: 'border-box',
  overflow: 'hidden',
  backgroundColor: colors.greyLight,
  paddingBottom: 140,
  paddingLeft: 20,
  paddingRight: 20,
});

export const Grid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 12,
  width: '100%',
});

export const BackButton = styled(Link)({
  alignSelf: 'flex-start',
  width: 32,
  height: 32,
  backgroundImage: `url(${arrowBack})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  marginTop: 20,
  marginBottom: 10,
});

export const Overlay = styled('div')({
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1000,
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
});

export const Sheet = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: 500,
  maxHeight: '85vh',
  overflowY: 'auto',
  padding: '40px 24px calc(32px + env(safe-area-inset-bottom))',
  borderRadius: '20px 20px 0 0',
  backgroundColor: colors.white,
});

export const CloseButton = styled('button')({
  position: 'absolute',
  top: 14,
  right: 14,
  width: 32,
  height: 32,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: 15,
    left: 6,
    width: 20,
    height: 2,
    backgroundColor: colors.darkBrown,
  },
  '&::before': {transform: 'rotate(45deg)'},
  '&::after': {transform: 'rotate(-45deg)'},
});

export const DetailTitle = styled('h2')({
  margin: '0 0 16px',
  color: colors.darkBrown,
  fontFamily: fonts.title,
  fontSize: 24,
  lineHeight: 1.2,
  textAlign: 'center',
});

export const DetailImage = styled('img')({
  width: 92,
  height: 'auto',
  marginBottom: 16,
});

export const DetailText = styled('div')({
  alignSelf: 'stretch',
  marginBottom: 16,
  color: colors.black,
  fontFamily: fonts.default,
  fontSize: 14,
  lineHeight: '22px',
  '& ul': {margin: 0, paddingLeft: 20},
  '& li': {marginBottom: 8},
  '& p': {margin: '0 0 8px'},
});

export const FileField = styled('label')({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  marginBottom: 4,
  color: colors.darkBrown,
  fontFamily: fonts.default,
  fontSize: 14,
  fontWeight: 'bold',
  '& input': {
    fontFamily: fonts.default,
    fontSize: 14,
    fontWeight: 'normal',
  },
});

export const FileName = styled('div')({
  marginBottom: 4,
  color: colors.grey,
  fontSize: 12,
  wordBreak: 'break-all',
});

export const FieldHint = styled('p')({
  margin: '0 0 12px',
  color: colors.grey,
  fontFamily: fonts.default,
  fontSize: 12,
  lineHeight: '18px',
});

export const CommentField = styled('textarea')({
  width: '100%',
  minHeight: 80,
  marginBottom: 12,
  padding: 10,
  border: `1px solid ${colors.beige}`,
  borderRadius: 0,
  fontFamily: fonts.default,
  fontSize: 14,
  resize: 'vertical',
});

export const FieldError = styled('p')({
  margin: '0 0 12px',
  color: '#C0392B',
  fontFamily: fonts.default,
  fontSize: 13,
  lineHeight: '18px',
});

export const Confirmation = styled('p')({
  margin: '16px 0',
  color: colors.darkBrown,
  fontFamily: fonts.default,
  fontSize: 16,
  lineHeight: '24px',
  textAlign: 'center',
});
